import UserComponent from "../../modules/users/templete/UserComponent";


const UserTablePage = () => {
 
  return (
    <>
      <UserComponent />
    </>
  );
};

export default UserTablePage;
